import { ComponentStyleConfig } from '@chakra-ui/react'

export const Divider: ComponentStyleConfig = {
    baseStyle: {
        borderColor: 'green.transparent_18',
    },
}
